import React, { useState } from 'react';
import { Search } from 'lucide-react';
import C from '../../constants/colors';
import { TX_ACTION_META } from '../../constants/meta';

export default function SiteAccessHistory({ transactions }) {
  const [search, setSearch] = useState('');
  const [filterFrom, setFilterFrom] = useState('');
  const [filterTo, setFilterTo] = useState('');

  const filtered = transactions.filter(tx => {
    if (filterFrom && new Date(tx.timestamp) < new Date(filterFrom)) return false;
    if (filterTo && new Date(tx.timestamp) > new Date(filterTo + 'T23:59:59')) return false;
    if (search.trim()) {
      const q = search.toLowerCase();
      if (!tx.employeeName?.toLowerCase().includes(q) && !tx.employeeIdCode?.toLowerCase().includes(q)) return false;
    }
    return true;
  });

  const inpStyle = { background: C.surfaceElevated, border: `1px solid ${C.border}`, borderRadius: '8px', padding: '7px 10px', color: C.textPrimary, fontSize: '12px', fontFamily: 'inherit', outline: 'none', width: '140px' };

  return (
    <div>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center', marginBottom: '14px' }}>
        <div style={{ position: 'relative' }}>
          <Search size={12} color={C.textMuted} style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)' }} />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Name or ID..."
            style={{ ...inpStyle, paddingLeft: '28px', width: '180px' }} />
        </div>
        <input type='date' value={filterFrom} onChange={e => setFilterFrom(e.target.value)} style={inpStyle} />
        <input type='date' value={filterTo} onChange={e => setFilterTo(e.target.value)} style={inpStyle} />
        {(search || filterFrom || filterTo) && (
          <button onClick={() => { setSearch(''); setFilterFrom(''); setFilterTo(''); }}
            style={{ padding: '7px 12px', borderRadius: '8px', border: `1px solid ${C.border}`, background: 'transparent', color: C.textMuted, fontSize: '12px', cursor: 'pointer', fontFamily: 'inherit' }}>
            Clear
          </button>
        )}
        <span style={{ marginLeft: 'auto', fontSize: '12px', color: C.textMuted }}>{filtered.length} records</span>
      </div>
      <div style={{ background: C.surfaceElevated, borderRadius: '12px', border: `1px solid ${C.border}`, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ borderBottom: `1px solid ${C.border}` }}>
                {['Date & Time','Employee','ID','Dept','Action','Zone','Status','Source','GPS'].map(h => (
                  <th key={h} style={{ padding: '10px 10px', textAlign: 'left', fontSize: '10px', fontWeight: 600, color: C.textMuted, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((tx, i) => {
                const meta = TX_ACTION_META[tx.action] || { label: tx.action, color: C.textMuted };
                return (
                  <tr key={tx.id + i} style={{ borderBottom: `1px solid ${C.border}`, background: i%2===0?'transparent':'rgba(255,255,255,0.01)' }}>
                    <td style={{ padding: '9px 10px', fontFamily: 'JetBrains Mono, monospace', fontSize: '11px', color: C.textSecondary, whiteSpace: 'nowrap' }}>
                      {new Date(tx.timestamp).toLocaleString()}
                    </td>
                    <td style={{ padding: '9px 10px', fontWeight: 600, color: C.textPrimary, whiteSpace: 'nowrap' }}>{tx.employeeName}</td>
                    <td style={{ padding: '9px 10px', fontFamily: 'JetBrains Mono, monospace', color: C.textSecondary, fontSize: '11px' }}>{tx.employeeIdCode}</td>
                    <td style={{ padding: '9px 10px', color: C.textSecondary }}>{tx.department}</td>
                    <td style={{ padding: '9px 10px' }}>
                      <span style={{ fontSize: '11px', background: meta.color + '22', color: meta.color, padding: '2px 7px', borderRadius: '5px', fontWeight: 600, whiteSpace: 'nowrap' }}>{meta.label}</span>
                    </td>
                    <td style={{ padding: '9px 10px', color: C.textMuted }}>{tx.zoneName || '—'}</td>
                    <td style={{ padding: '9px 10px', whiteSpace: 'nowrap' }}>
                      <span style={{ fontSize: '11px', color: tx.statusAfter === 'SAFE' ? C.green : tx.statusAfter === 'NEED_HELP' ? C.red : tx.statusAfter === 'EVACUATED' ? C.orange : C.textSecondary, fontWeight: 600 }}>{tx.statusAfter}</span>
                    </td>
                    <td style={{ padding: '9px 10px', fontSize: '11px', color: C.textMuted }}>{tx.source}</td>
                    <td style={{ padding: '9px 10px', fontFamily: 'JetBrains Mono, monospace', fontSize: '10px', color: C.textMuted, whiteSpace: 'nowrap' }}>
                      {tx.gps ? `${tx.gps.lat.toFixed(4)}, ${tx.gps.lng.toFixed(4)}` : '—'}
                    </td>
                  </tr>
                );
              })}
              {filtered.length === 0 && (
                <tr><td colSpan={9} style={{ padding: '40px', textAlign: 'center', color: C.textMuted }}>No access history for this site yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
